// addonsValidation.js
import * as Yup from "yup";

export const initialValues = {
  addon_name: "",
  addons_price: "",
  imgpath: "",
};

export const validationSchema = Yup.object({
  addon_name: Yup.string().required("Addons Name is required"),
  addons_price: Yup.number()
    .typeError("Price must be a number")
    .positive("Price must be greater than zero")
    .required("Price is required"),
});
